export const api = {
    data : function () {
        return {
            api : 'https://admin.ghostapp.co.uk/api/'
            // api : 'https://ghost.test/api/'
        }
    }
};
